import { SET_STATE, RESET, ADD_WORKOUTS } from './actionTypes'
import { receiveEndPointMessage } from '../otuVision/actions';

function initialState( preserve = {} ) {
return Object.assign({},{
    visible : false,
    chooseWorkout : false,
    workingOut: false,
    workout : null,
    workouts : [],
    player : null,
    }, preserve )
}
  


export default function (state = initialState(), action) {

    switch (action.type) {

        case SET_STATE:

            const newState = action.newState
            
            for ( var key in newState ) {
                if ( newState.hasOwnProperty( key ) && state.hasOwnProperty( key ) ) {
                    state[key] = newState[key]
                } 
            }

            break;

        case ADD_WORKOUTS:

            state.workouts = action.workouts

            break;

        case RESET : 

            state = initialState({
                workouts : state.workouts
            })
        
            break;
            
        default:
    }

    return state;

}


